/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type LogoutUserMutationInput = {
    clientMutationId?: string | null | undefined;
};
export type LogoutUserMutationVariables = {
    input: LogoutUserMutationInput;
};
export type LogoutUserMutationResponse = {
    readonly logoutUser: {
        readonly clientMutationId: string | null;
        readonly viewer: {
            readonly id: string;
            readonly user: {
                readonly id: string;
            } | null;
        } | null;
        readonly user: {
            readonly id: string;
        } | null;
    } | null;
};
export type LogoutUserMutation = {
    readonly response: LogoutUserMutationResponse;
    readonly variables: LogoutUserMutationVariables;
};



/*
mutation LogoutUserMutation(
  $input: LogoutUserMutationInput!
) {
  logoutUser(input: $input) {
    clientMutationId
    viewer {
      id
      user {
        id
      }
    }
    user {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            (v1 /*: any*/)
        ],
        "storageKey": null
    } as any, v3 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "LogoutUserMutationPayload",
            "kind": "LinkedField",
            "name": "logoutUser",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v2 /*: any*/)
                    ],
                    "storageKey": null
                },
                (v2 /*: any*/)
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "LogoutUserMutation",
            "selections": (v3 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "LogoutUserMutation",
            "selections": (v3 /*: any*/)
        },
        "params": {
            "cacheID": "97ced67ec09df37c253f4226d06c0ac5",
            "id": null,
            "metadata": {},
            "name": "LogoutUserMutation",
            "operationKind": "mutation",
            "text": "mutation LogoutUserMutation(\n  $input: LogoutUserMutationInput!\n) {\n  logoutUser(input: $input) {\n    clientMutationId\n    viewer {\n      id\n      user {\n        id\n      }\n    }\n    user {\n      id\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '4b8cd05f5e06e3e0ad30a8c30218c859';
export default node;
